__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-journey/v9_1_6/";